import { useFetchBadgeZoneViolationIncident } from "@/lib/hooks/badge-zone-violation-incident";
import { useFetchVehicle } from "@/lib/hooks/vehicle";
import { useFetchVehicleType } from "@/lib/hooks/vehicle-type";
import { useFetchDepartment } from "@/lib/hooks/department";
import { useFetchShift } from "@/lib/hooks/shift";
import { useFetchIncidentUser } from "@/lib/hooks/user";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { OperatorDetails } from "@/components/ui/operator-details";
import { VehicleDetails } from "@/components/ui/vehicle-details";
import { EventMetaCard } from "@/components/ui/event-meta-card";
import { useTranslation } from "react-i18next";
import { BadgeDetails } from "@/components/ui/badge-details";
import { useFetchPedestrianDevice } from "@/lib/hooks/pedestrian-device";

export type BadgeZoneViolationProps = {
    badgeZoneViolationIncidentId: string;
};

export const BadgeZoneViolation = ({
    badgeZoneViolationIncidentId,
}: BadgeZoneViolationProps): JSX.Element => {
    const { t } = useTranslation();
    const [badgeZoneViolationIncident, isBadgeZoneViolationIncidentLoading] =
        useFetchBadgeZoneViolationIncident(badgeZoneViolationIncidentId);
    const [pedestrianDevice, isPedestrianDeviceLoading] = useFetchPedestrianDevice(
        badgeZoneViolationIncident?.pedestrianDeviceId,
    );

    const [user, isUserLoading] = useFetchIncidentUser(badgeZoneViolationIncident?.userId);
    const [userDepartment, isUserDepartmentLoading] = useFetchDepartment(user?.departmentId);
    const [shift, isShiftLoading] = useFetchShift(user?.shiftId);

    const [vehicle, isVehicleLoading] = useFetchVehicle(badgeZoneViolationIncident?.vehicleId);
    const [vehicleType, isVehicleTypeLoading] = useFetchVehicleType(vehicle?.vehicleTypeId);
    const [vehicleDepartment, isVehicleDepartmentLoading] = useFetchDepartment(
        vehicle?.departmentId,
    );

    const loading =
        isBadgeZoneViolationIncidentLoading ||
        isPedestrianDeviceLoading ||
        isShiftLoading ||
        isUserDepartmentLoading ||
        isUserLoading ||
        isVehicleDepartmentLoading ||
        isVehicleLoading ||
        isVehicleTypeLoading;

    return (
        <>
            <EventMetaCard
                badgeZoneViolationIncident={badgeZoneViolationIncident}
                loading={loading}
            />
            <Card>
                <OperatorDetails
                    title={t("component.operatorDetails.title.operator")}
                    user={user}
                    unknown={false}
                    department={userDepartment}
                    shift={shift}
                    badgeLabel={t("component.operatorDetails.badge.driver")}
                    loading={loading}
                />
                <Separator className="mx-4" />
                <VehicleDetails
                    department={vehicleDepartment}
                    vehicle={vehicle}
                    vehicleType={vehicleType}
                    loading={loading}
                />
            </Card>
            <Card>
                <BadgeDetails
                    title={t("component.badgeDetails.title")}
                    badgeLabel={t("component.badgeDetails.badge.pedestrianModule")}
                    incident={badgeZoneViolationIncident}
                    pedestrianDevice={pedestrianDevice}
                    loading={loading}
                />
            </Card>
        </>
    );
};
